import { render, staticRenderFns } from "./OverlayGvsQuestions.vue?vue&type=template&id=0b92d002"
import script from "./OverlayGvsQuestions.vue?vue&type=script&lang=js"
export * from "./OverlayGvsQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports